export default __webpack_public_path__ + "041df19e2a4028e867be8ecb399118c2.png";